<template>
    <section class="checkout-section">
        <div class="section-header">
            <h2> {{ resources.flyIn.addNewHeading }}</h2>
        </div>
        <div class="section-row">
            <vue-form name="new-address">
                <div  v-for="element in nameElements" :key="element.id" class="vue-form-row">
                    <vue-input :element="element"
                    @blur="updateFieldValue(element.id, $event.target.value)"/>
                </div>

                <div class="vue-form-row" v-if="addressSearchElement && addressFieldsHidden">
                    <vue-input :element="addressSearchElement" />
                </div>

                <div v-if="addressFieldsHidden && hiddenElements" class="vue-form-row reveal-hidden" @click="addressFieldsHidden = false">
                {{ enterAddressCTA }}
                </div>

                <template v-if="!addressFieldsHidden && hiddenElements">
                    <div  v-for="element in hiddenElements" :key="element.id" class="vue-form-row">
                        <vue-input :element="element"
                            @blur="updateFieldValue(element.id, $event.target.value)" />
                    </div>
                </template>

                <div class="vue-form-row">
                    <vue-input :element="saveAddressElement"
                        @blur="updateFieldValue(saveAddressElement.id, $event.target.value)" />
                </div>
            </vue-form>
        </div>
        <footer class="section-footer">
            <button class="btn btn--secondary" @click="cancel" :disabled="showSpinner"> {{ resources.flyIn.cancelCTA }} </button>
            <button class="btn" @click="useThisAddress" :disabled="showSpinner">
                <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <template v-if="!showSpinner">
                    {{resources.flyIn.useCTA}}
                </template>
            </button>
        </footer>
    </section>
</template>
<script src="./add-new-address.js"/>
